import styled from 'styled-components/macro'

import { Overlay, Thread } from 'styles/misc'
import { mq } from 'styles/mq'
import { GraphicsImage } from '../../../styled'

export const Placeholder = styled(GraphicsImage)`
  opacity: 0.01;
`

export const SlideImage = styled.img<{ isActive: boolean }>`
  ${Overlay}
  transition: 0.3s opacity;
  opacity: ${props => (props.isActive ? 1 : 0.01)};
`

export const ImageWrapper = styled.div`
  max-width: 29rem;
  position: relative;

  ${mq.medium} {
    max-width: 51rem;
  }

  ${mq.large} {
    width: 51rem;
    aspect-ratio: 1380 / 795;
    margin: 0 5rem 0 16rem;
  }

  > ${GraphicsImage} {
    ${mq.medium} {
      margin-right: 0;
    }
  }
`

export const ThreadGraphics = styled.span.attrs({ 'aria-hidden': 'true' })`
  &::before {
    ${Thread}
    width: 100%;
    aspect-ratio: 1829 / 960;
    transform: translateY(-40%) translateY(10rem);
    mask-image: url("data:image/svg+xml,%3Csvg width='1828.9' height='959.94' viewBox='0 0 1828.9 959.94' fill='none' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink'%3E%3Cpath d='m.32,143.88C68.77,85.74,146.17,35.47,233.05,12.74c86.88-22.73,184.44-15.23,259.16,34.59,74.72,49.81,120.39,145.98,97.58,232.84-6.95,26.48-19.75,54.12-10.75,79.98,14.49,41.61,70.67,46.09,114.62,43.04,89.33-6.19,178.66-12.39,267.99-18.58,87.48-6.06,185.22-8.88,251.11,48.98,41.11,36.1,65.58,93.02,116.24,113.68,19.3,7.87,40.53,9.48,61.37,9.97,55.73,1.32,111.55-4.64,167.17-.88,55.61,3.76,112.79,18.47,154.62,55.3,29.01,25.54,48.72,59.99,64.45,95.3,35.31,79.23,53.1,166.22,51.71,252.96' stroke='black' stroke-width='1.5px' vector-effect='non-scaling-stroke'/%3E%3C/svg%3E");

    ${mq.large} {
      transform: translateY(-40%) translateY(25rem);
    }
  }
`
